import BraftEditor from "braft-editor";
import { Modal } from 'antd';
import { convertTimestampToFormat, dateFormat } from "@lib/dateTime";
import { ReButton } from "@/components/refineElement";
import { getLangList } from "@/lib/i18n";

type Props = {
  scheduleItem: any;
  onCancel: () => void;
}

function ScheduleModal(props: Props) {
  const { onCancel, scheduleItem } = props;
  const { startTime, departmentName, title, content } = scheduleItem;
  const buttonT: any = getLangList("button");

  return (
    <Modal
      open={true}
      width='1000px'
      title={`${convertTimestampToFormat(startTime, dateFormat)} ${departmentName}： ${title}`}
      onCancel={onCancel}
      footer={[
        <ReButton key="confirm" onClick={onCancel}>
          {buttonT.OK}
        </ReButton>
      ]}
    >
      <BraftEditor
        readOnly
        controlBarStyle={{ display: 'none' }}
        defaultValue={BraftEditor.createEditorState(content)}
      />
    </Modal>
  );
};

export default ScheduleModal;